<div *ngIf="isMobile; else webLogin" class="full-container">
  <div class="logos-mobile">
    <img class="bescom-logo" src="assets/BESCOM_logo.png" alt="">
    <!-- <img class="panchami-logo" src="assets/Panchami_Logo.png" alt=""> -->
  </div>
  <div class="welcome-container">
    <div class="top-content">
      <div class="welcome-text-english-mobile">
        Peer-to-Peer Energy <br> Trading Platform
      </div>
      <div class="welcome-text-south-mobile">
        ಪಿಯರ್-ಟು-ಪಿಯರ್ <br>
        ವಿದ್ಯುತ್ ಶಕ್ತಿ ವಿನಿಮಯ ವೇದಿಕೆ  
      </div>
    </div>
    <div class="bottom-content">
      <div class="login-text-english-mobile">
        Please login if you have <br> an account otherwise register
      </div>

      <div class="login-text-south-mobile">
        ಲಾಗಿನ್ ಅಥವಾ ರಜಿಸ್ಟರ್ ಮಾಡಿ
      </div>
      <div class="register-and-login-buttons">
        <div class="register-button-mobile">
            <button type="register" (click)="navigateTo('login', 'register')">REGISTER</button>
        </div>
        <div class="login-button-mobile">
            <button type="login" (click)="navigateToLogin()">LOGIN</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #webLogin>
  <div class="header">
    <img class="img" src="assets/logo_transparent.png" />
     <div class="title">Welcome to Peer to Peer Solar Energy Trading</div>
   </div>
   <div class="watermark">
     <img class="watermark-img" src="assets/Group 136.png" />
     <!-- <div class="logo-container">
  <img class="side-logo" src="assets/bescom logo.svg" alt="BESCOM Logo">
</div> -->
<!-- <img class="img-1" src="assets/bescom logo.svg" alt="BESCOM Logo"> -->
  <img class="img-1" src="assets/logo_with_text.png" />
     <img class="line-img-1" src="assets/Line 6.png" />
     <img class="line-img-2" src="assets/Line 6.png" />
     <img class="hygge-img" src="assets/My project (1) 3 (1).png" />
   </div>
   <div class="welcome-box">
     <img class="img-2" src="assets/logo_transparent.png" />
     <h4 id="welcome-title">
       Welcome
       <p class="title-a">to the</p>
       <br />Peer to Peer Solar Energy <br />Trading
     </h4>
     <p class="title-b">
       Login if you have account <br />else <br />Please Register
     </p>
     <div class="form-actions">
       <button type="login" (click)="navigateToLogin()">Login</button>
       <button type="register" (click)="navigateTo('login', 'register')">Register</button>
     </div>
   </div>
</ng-template>


